"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialCovenantDirectInsertRecordsStruct = exports.FinancialCovenantDirectInsertRecordStruct = exports.FinancialCovenantWorkleaseSchema = exports.FinancialCovenantWorkleaseModeSchema = exports.FinancialCovenantRecordIdMapSchema = exports.FinancialCovenantWorkleaseModeIterable = exports.RequiredFinancialCovenantField = exports.RequiredFinancialCovenantFieldIterable = exports.FinancialCovenantResultIterable = void 0;
const zod_1 = require("zod");
const Utils_1 = require("./Utils");
exports.FinancialCovenantResultIterable = [
    'PASS',
    'FAIL',
    'LEVEL_1_FAIL',
    'LEVEL_2_FAIL',
    'LEVEL_3_FAIL',
    'LEVEL_4_FAIL',
    'LEVEL_5_FAIL',
    'LEVEL_6_FAIL',
    'LEVEL_7_FAIL',
    'LEVEL_8_FAIL',
    'LEVEL_9_FAIL',
    'LEVEL_10_FAIL',
];
/**
 * Required financial covenant field keys used throughout the codebase
 * for intermediate field validation and configuration.
 */
exports.RequiredFinancialCovenantFieldIterable = [
    'financialCovenantReportingDate',
    'financialCovenantValue',
    'financialCovenantResult',
];
exports.RequiredFinancialCovenantField = {
    FinancialCovenantReportingDate: 'financialCovenantReportingDate',
    FinancialCovenantValue: 'financialCovenantValue',
    FinancialCovenantResult: 'financialCovenantResult',
};
exports.FinancialCovenantWorkleaseModeIterable = ['QA', 'RESULT'];
const FinancialCovenantStatusIterable = [
    'initialized',
    'success',
    'error',
];
exports.FinancialCovenantRecordIdMapSchema = zod_1.z.object({
    covenantKey: zod_1.z.string(),
    // Represents DB record since we initialize one even before evaluation
    financialCovenantRecordId: zod_1.z.string(),
});
exports.FinancialCovenantWorkleaseModeSchema = zod_1.z.enum(exports.FinancialCovenantWorkleaseModeIterable);
// This is what is sent to FinCov lambda that manages the evaluation.
// Convert the "covenantKeys" into DB records and send that along.
// This applies to both "QA" and "Live" mode at the moment, can split
// them up as needed
exports.FinancialCovenantWorkleaseSchema = zod_1.z.object({
    mode: exports.FinancialCovenantWorkleaseModeSchema,
    triggerDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    creditAgreementId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    finCovRecordMaps: zod_1.z.array(exports.FinancialCovenantRecordIdMapSchema),
});
exports.FinancialCovenantDirectInsertRecordStruct = zod_1.z.object({
    financialCovenantKey: zod_1.z.string(),
    value: zod_1.z.number(),
});
exports.FinancialCovenantDirectInsertRecordsStruct = zod_1.z.array(exports.FinancialCovenantDirectInsertRecordStruct);
//# sourceMappingURL=FinancialCovenants.js.map